import { Order } from '@spike/order-model';
import { CheckoutType } from '../Checkout';

export const getCheckoutTypeFromOrder = (order: Order): CheckoutType => {
    if (order.items.memberships.length > 0) {
        return 'membership';
    }

    if (order.items.appointments.length > 0) {
        return 'booking';
    }

    return 'singlesale';
};
